import React, { Suspense } from 'react'
import type { ComponentType } from 'react'
import type { IAllProps } from '@tinymce/tinymce-react'
import { loadTinyMCEDependencies } from './loadTinyMCEDependencies'
import Spinner from 'components/Spinner'

const LazyEditor = React.lazy(
  async (): Promise<{ default: ComponentType<any> }> => {
    await loadTinyMCEDependencies()
    const mod = await import('@tinymce/tinymce-react')
    return { default: (mod.Editor as unknown) as ComponentType<any> }
  },
)

export default function BundledEditor(props: IAllProps) {
  return (
    <Suspense fallback={<Spinner fontSize={80} />}>
      <LazyEditor licenseKey="gpl" {...props} />
    </Suspense>
  )
}
